import React from "react";
import "./About.css";

export default function About() {
  return (
    <main className="about">
      <div className="about-inner">
        <aside className="about-img">
          <img src="/about.png" alt="Marian Melnyk" />
        </aside>
        <section className="about-text">
          <h1 className="about-title">About</h1>
          <p className="about-paragraph">
            A fifth-year PhD candidate in Economics at the CUNY Graduate Center
            and an Adjunct Lecturer at City College of New York.
            <br /> <br />
            My research is motivated by questions of development, productivity,
            and welfare. I am interested in how institutions, labor markets,
            technology, and political organization shape the broader economic
            well-being of individuals and societies. I work primarily at the
            intersection of labor economics, macroeconomics, and political
            economy, often using historical settings to study general questions
            of economic change.
            <br /> <br />
            My current work studies how organizational technologies such as
            remote work affect labor-market participation, how reductions in
            mobility costs shape local economic activity, and how political
            organization, institutions, and governance traditions shape long-run
            development.
            <br /> <br />
            Originally from Ukraine, I earned a BA in Political Science from the
            National University of Kyiv-Mohyla Academy and an MA in Economics
            from the Kyiv School of Economics, before moving to New York to
            continue my doctoral studies.
          </p>
          <a
            href="/CV_Marian_Melnyk_2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="cv-button"
          >
            Download CV
          </a>
        </section>
      </div>
    </main>
  );
}
